const locations = [
    {'value': 'vn', 'label': 'vn'},
    {'value': 'default', 'label': 'default'}
]

export default locations
